import { defineComponent as _defineComponent } from 'vue'
import Search from '@/components/layout/inputs/GlobalSearch.vue';
import EventBus from '@/EventBus';
import { TRIGGER_SEARCH_INPUT } from '@/events';
import { User } from '@/models/User';
import { onMounted, onUnmounted, ref } from 'vue';
import useStore from '@/composables/useStore';
import authService from '@/services/AuthService';
import { useRouter } from 'vue-router/composables';


const __default__ = { name: 'HomePage' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const user = ref<User>(null);
const windowWidth = ref(0);

const store = useStore();
const router = useRouter();

function handleWindowResize() {
  windowWidth.value = window.innerWidth;
}

onMounted(async () => {
  window.addEventListener('resize', handleWindowResize);
  handleWindowResize();

  user.value = authService.user;
  EventBus.$emit(TRIGGER_SEARCH_INPUT, false);

  //open articleEditor after extension load
  if (store.state.articleEditor.editDraftExtension) {
    await router.push('draft/' + store.state.articleEditor.editDraftExtension);
    store.commit('setArticleEditorEditDraftExtension', undefined);
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', handleWindowResize);
});

return { __sfc: true,user, windowWidth, store, router, handleWindowResize, Search }
}

})